export const GLOBAL_SEARCH_CATEGORIES = {
  faq: 'Regulatory FAQs',
  regsAndGuidances: 'Regulations & Guidance',
  regWatch: 'Regulatory Watch'
};

export const GLOBALSEARCH_MAPPING = {
  'Regulatory FAQs': 'Regulatory Intelligence',
  'Regulatory Watch': 'Regulatory Watch',
  'Regulatory Process Charts': 'Regulatory Intelligence',
  Records: 'Registration Tracker',
  'Regulatory Reports': 'Regulatory Reports',
  'Smart Builder': 'Smart Builder',
  'Product Classification': 'Product Classification'
};

export const GLOBAL_SEARCH_SERVICES_MAPPING = {
  'Regulatory Watch': ['regWatch'],
  'Regulatory Intelligence': ['faq', 'process charts'],
  'Regulations & Guidance': ['regsAndGuidances']
};

export const FREE_SEARCH_SERVICES = [
  'Regulations & Guidance',
  'Government Fee Finder',
  'Guides and Templates',
  'FDA Product Classification Lookup',
  '510 (K) Review Time Calculator',
  'Marketplace',
  'Agreements',
  'Product Tracker',
  'Notifications',
  'Dashboard'
];
